import { __decorate } from "tslib";
import { attr } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/mixin';
import { Breadcrumb } from '@microsoft/fast-foundation';
const MAX_ITEM_TO_SHOW = 4;
export class BreadcrumbComponent extends ChameleonElementMixin(Breadcrumb) {
    constructor() {
        super(...arguments);
        this.variant = 'default';
        this.containerEl = document.createElement('div');
    }
    variantChanged(_, next) {
        if (next === 'overflow-content' && this.containerEl.children.length > MAX_ITEM_TO_SHOW) {
            this.addPopoverWhenIsOverflowContent();
        }
        if ((!next || next === 'default') && this.slottedBreadcrumbItems && this.slottedBreadcrumbItems.length > 0) {
            this.copySlottedItemsToContainer(this.slottedBreadcrumbItems);
        }
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        this.containerEl.setAttribute('role', 'list');
        this.containerEl.classList.add('container');
        (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.appendChild(this.containerEl);
    }
    // @ts-expect-error In the FAST definition the arguments to this function are not defined so TS errors because it thinks these are differen types
    slottedBreadcrumbItemsChanged(_, next) {
        super.slottedBreadcrumbItemsChanged();
        if (next && next.length > 0) {
            this.copySlottedItemsToContainer(next);
        }
        if (next && next.length > MAX_ITEM_TO_SHOW) {
            this.addPopoverWhenIsOverflowContent();
        }
    }
    copySlottedItemsToContainer(items) {
        this.removeItemsFromContainer();
        const lastItem = items.at(-1);
        for (const item of items) {
            const isLastItem = item === lastItem;
            const clone = item.cloneNode(true);
            if (isLastItem) {
                clone.separator = false;
                // removing the href attribute displays the last breadcrumb as a simple text and not a link
                clone.removeAttribute('href');
            }
            this.containerEl.appendChild(clone);
        }
    }
    removeItemsFromContainer() {
        while (this.containerEl.firstChild) {
            this.containerEl.removeChild(this.containerEl.firstChild);
        }
    }
    addPopoverWhenIsOverflowContent() {
        const dotsItem = document.createElement('chameleon-breadcrumb-item');
        dotsItem.classList.add('goto-breadcrumb-dots');
        const dotsPopover = document.createElement('chameleon-popover');
        dotsPopover.setAttribute('menu', '');
        dotsPopover.setAttribute('position', 'bottom-start');
        const span = document.createElement('span');
        span.setAttribute('slot', 'trigger');
        span.textContent = '...';
        const divContent = document.createElement('div');
        divContent.setAttribute('slot', 'content');
        const chameleonMenu = document.createElement('chameleon-menu');
        chameleonMenu.setAttribute('role', 'menu');
        chameleonMenu.classList.add('goto-breadcrumb-overflow-items');
        divContent.appendChild(chameleonMenu);
        dotsPopover.appendChild(span);
        dotsPopover.appendChild(divContent);
        const breadCrumbItems = Array.from(this.containerEl.children);
        // We only iterate through the 1...n-3 elements, becase by design we always want to display the first
        // the last and the second to last breadcrumbs and only put the rest inside a popover
        for (let i = 1; i <= breadCrumbItems.length - 3; i++) {
            const child = breadCrumbItems[i];
            const linkMenuItem = document.createElement('chameleon-breadcrumb-item');
            const href = child.getAttribute('href');
            if (href) {
                linkMenuItem.setAttribute('href', href);
            }
            linkMenuItem.innerHTML = child.innerText;
            linkMenuItem.classList.add('menu-item');
            chameleonMenu.appendChild(linkMenuItem);
            child.remove();
        }
        dotsItem.appendChild(dotsPopover);
        this.containerEl.children[0].insertAdjacentElement('afterend', dotsItem);
    }
}
__decorate([
    attr()
], BreadcrumbComponent.prototype, "variant", void 0);
